import React,  { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../../../containers';
import { Navbar } from '../../../../components';
import './Methodos-Ekpaideusis.css';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../../../assets/OEFE.jpg';
import labora from '../../../../assets/labora.jpg';
import edu4schools from '../../../../assets/edu4schools.png';
import ypourgeio from '../../../../assets/ypourgeio.jpg';
import Video1 from './Photo/Methodos-video.mp4';

const categories = [
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") },
  { title: "image1", image: require("./Photo/image1.jpg") }
];

const styles = {
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    padding: "20px",
    maxWidth: "1000px",
    margin: "auto",
  },
  gridItem: {
    background: "white",
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    textAlign: "center",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s ease-in-out",
    cursor: "pointer",
  },
  gridItemHover: {
    transform: "scale(1.05)",
  },
  gridImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
  },
  title: {
    padding: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    background: "#f8f8f8",
  },
  fullscreenOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "1000",
  },
  fullscreenImage: {
    maxWidth: "90%",
    maxHeight: "90%",
    
  },
};

const Methodos = () => {
  
    const form = useRef();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
  
    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
        .then((result) => {
            console.log(result.text);
            console.log("message sent");
            e.target.reset();
            setShowSuccess(true);
            setShowError(false);
        }, (error) => {
            console.log(error.text);
            setShowSuccess(false);
            setShowError(true);
        });
    };
  
    const closePopup = () => {
      setShowSuccess(false);
      setShowError(false);
    };

  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <div className="Methodos">
        <div className="gradient__bg">
          <Navbar className="navbar" />
        </div>
        <div className="Methodos__main-container">
          <div className="Methodos__container">
            <div className="Methodos__container-h">
              <h1>Μέθοδος Εκπαίδευσης</h1>
            </div>
            <div style={styles.gridContainer}>
              {categories.map((category, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.gridItem,
                    ...(hoverIndex === index ? styles.gridItemHover : {}),
                  }}
                  onClick={() => setFullscreenImage(category.image)}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(null)}
                >
                  <img src={category.image} alt={category.title} style={styles.gridImage} />
                  <div style={styles.title}>{category.title}</div>
                </div>
              ))}
            </div>
            {fullscreenImage && (
              <div
                style={styles.fullscreenOverlay}
                onClick={() => setFullscreenImage(null)}
              >
                <img src={fullscreenImage} alt="Fullscreen" style={styles.fullscreenImage} />
              </div>
            )}
            <div className="Methodos__container-p">
            <h2>&nbsp;&nbsp;&nbsp;Το φροντιστήριο μας ακολουθεί την ΟΜΑΔΟΣΥΝΕΡΓΑΤΙΚΗ ΜΑΘΗΣΗ (COLLABORATIVE LEARNING)</h2>
              <p>&nbsp;&nbsp;&nbsp;Η  ομαδική συνεργασία δημιουργεί μία αναπτυξιακή δυναμική που επιτρέπει στα μέλη της ομάδας να ξεπεράσουν τα ατομικά τους όρια σκέψης και πράξης. Έτσι, τα συνεργαζόμενα μέλη μπορούν να αναπτύξουν συλλογικές μορφές σκέψης και δράσης που κανένα από τα μέλη δεν θα μπορούσε ατομικά, εκτός ομάδας, να αναπτύξει. Η γνώση θεωρείται ως ένα κοινωνικό κατασκεύασμα, που παράγεται μέσα από την  αλληλεπίδραση, τη συζήτηση, την αντίδραση, την αξιολόγηση και τη συνεργασία με τους άλλους.</p>
              <p>&nbsp;&nbsp;&nbsp;Σε περιβάλλοντα που ευνοούν τη συνεργασία, οι μαθητές μαθαίνουν να μοιράζονται πληροφορίες και ιδέες, να ανταλλάσσουν επιχειρήματα, να συζητούν για την εργασία τους, να υλοποιούν εργασίες συνεργαζόμενοι με άλλους συμμαθητές, να βοηθούν και να σέβονται ο ένας τον άλλο.</p>
              <p>&nbsp;&nbsp;&nbsp;Σε συναισθηματικό επίπεδο, οι ομάδες δημιουργούν ένα ευνοϊκό κλίμα για μάθηση μέσω των κινήτρων και της μείωσης του άγχους. Οι ψυχοκοινωνιολόγοι, μάλιστα, επισημαίνουν ότι οι αντιδράσεις των μελών της ομάδας έχουν θετικές επιδράσεις στην ανάπτυξη της αυτοαντίληψης του παιδιού και στη διαδικασία εσωτερίκευσης  των κοινωνικών ρόλων. Σε γνωστικό επίπεδο, ένας μαθητής που εργάζεται σε μια ομάδα αναπτύσσει ανώτερης τάξης νοητικές διεργασίες.</p>
              <p>&nbsp;&nbsp;&nbsp;Έτσι, λοιπόν, η προτίμηση που δείχνουν κάποιοι στην ατομική διδασκαλία, αν δεν αποτελεί λύση ανάγκης, οφείλεται μάλλον σε άγνοια ή σε παραπληροφόρηση. Το παιδί και ο έφηβος, αλλά και ο ενήλικας, μαθαίνουν καλύτερα το «τι» και το «πώς» μαζί με τους άλλους. “Learning together, learning to live together”, όπως διακηρύσσει και η UNESCO.</p>
              <h3>&nbsp;&nbsp;&nbsp;«Η ομαδοσυνεργατική διδασκαλία ωφελεί πολλαπλώς»</h3>
                  <p>&nbsp;&nbsp;&nbsp;&bull; δίνει την ευκαιρία σε όλους τους μαθητές να συμμετέχουν ενεργητικά,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; δίνει τη δυνατότητα στους μαθητές να εκφράζουν ελεύθερα τη γνώμη τους στην ομάδα,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; συμβάλλει στην ανάπτυξη των κοινωνικών σχέσεων των μαθητών,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; δίνει την ευκαιρία στον εκπαιδευτικό να αυτενεργεί,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; ενδυναμώνει το ενδιαφέρον των μαθητών για το συγκεκριμένο διδακτικό αντικείμενο,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; οι μαθητές μαθαίνουν ο ένας από τον άλλο,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; οι μαθητές αναπτύσσουν κριτική σκέψη,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; βελτιώνεται ο προφορικός λόγος των μαθητών και εξοικειώνονται στη δημόσια παρουσίαση,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; οι διαφορετικές απόψεις στο εσωτερικό των ομάδων αποτελούν πηγή μάθησης,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; οι χαμηλού ακαδημαϊκού επιπέδου μαθητές δραστηριοποιούνται από τις απόψεις και τη δραστηριότητα των μαθητών που έχουν καλύτερη επίδοση,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; προάγεται η συνεργατική ικανότητα,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; εξασκεί τη δημοκρατική συμπεριφορά,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; εξασφαλίζει θετικές εμπειρίες από την κοινωνική ζωή,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; αυξάνει το σεβασμό των μαθητών για όλους τους συμμαθητές τους,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; καλλιεργεί την πρωτοβουλία,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; συμβάλλει στην ανάπτυξη της θετικής αυτοαντίληψης,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; μειώνει το άγχος που έχουν οι μαθητές για το σχολείο,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; δραστηριοποιεί όλους τους μαθητές, ακόμη και τους συνεσταλμένους,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; μαθαίνει στους μαθητές το διάλογο και το σεβασμό των απόψεων των άλλων.</p>
            </div>
          </div>
          <div className="Methodos__side-Containers">
            <div className="Methodos__side-Container1">
              <h1>Χρήσιμες Σελίδες</h1>
              <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <a href="/OmadaMonada" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div>
            <div className='xwroi-video'>
                <video width="70%" controls autoPlay muted loop>
                    <source src={Video1} type="video/mp4"/>
                    error
                  </video>
                </div>
            <div className="anodos__alykeiou-email-container">
              <form className="anodos__alykeiou-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="anodos__alykeiou-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="anodos__alykeiou-email-container_label">Όνομα</label>
                <input className="anodos__alykeiou-email-container_input" type="text" name="user_name" required/>
                <label className="anodos__alykeiou-email-container_label">Email</label>
                <input className="anodos__alykeiou-email-container_input" type="email" name="user_email" required/>
                <label className="anodos__alykeiou-email-container_label">Μήνυμα</label>
                <textarea className="anodos__alykeiou-email-container_input-message" name="message" required/>
                <input className="anodos__alykeiou-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="anodos__Alykeiou-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
          </div>
        </div>
        <Footer />
    </div>
  )
}

export default Methodos